export default (window as any).DD_LOGS?.logger;
// TODO: extend typing of window object
// https://stackoverflow.com/questions/56457935/typescript-error-property-x-does-not-exist-on-type-window
